import { render, staticRenderFns } from "./MediaContact.vue?vue&type=template&id=d753894c&scoped=true"
import script from "./MediaContact.vue?vue&type=script&lang=js"
export * from "./MediaContact.vue?vue&type=script&lang=js"
import style0 from "./MediaContact.vue?vue&type=style&index=0&id=d753894c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d753894c",
  null
  
)

export default component.exports